export class Metric {
    id?: Number;
    name: string;
    description: string;
    defaultValue?: string;
    measureUnitId?: string;
    deleted?: boolean;
    is_invalid?: boolean;
  
    constructor() {
      this.name = "";
      this.description = "";
      this.defaultValue = ""
      this.measureUnitId = ""
    }
  }